import React from 'react'
import { Logo } from './Logo'
import { Button, Title } from '@arvoreeducacao/bonsai-ds'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { LOGOUT_PATH } from 'routes/paths'
import { useHistory } from 'react-router-dom'
import type { LandingPageProps } from './LandingPage.types'
import { Cdn } from 'utils/assets'
import { useSuperAutorEligible } from 'utils/hooks/use-super-autor-eligible/useSuperAutorEligible'
import { getSuperAutorUrl } from 'components/modular/tabs-home/constants'
import { getFamilyPayingProductYear } from 'utils/family-paying'
import { OrderCodeForm } from '../order-code'

export const LandingPage: React.FC<LandingPageProps> = ({ onRedeemed }) => {
  const { user } = useUserInfo()
  const history = useHistory()
  const { hasCriarModuleAndFlag } = useSuperAutorEligible()
  const productYear = getFamilyPayingProductYear()

  const handleClick = () => {
    window.open('https://bookfair.com.br/', '_blank')
  }

  const handleLogoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    history.push(LOGOUT_PATH)
  }

  return (
    <div className="min-h-screen flex flex-col font-sans relative overflow-hidden">
      <img
        src={Cdn.getImageUrl('bookfair/book-with-leaves.png')}
        alt=""
        aria-hidden="true"
        className="absolute bottom-0 right-0 w-80 md:w-96 lg:w-[512px] opacity-25 transform translate-y-1/4 translate-x-1/4 pointer-events-none"
      />

      <header className="absolute top-0 left-0 p-6 md:p-8">
        <Logo className="h-9 w-auto" />
      </header>

      <main className="grow flex flex-col justify-center items-center text-center px-4 py-20">
        <div className="w-full max-w-3xl">
          <Title size={1}>Mais praticidade para você!</Title>
          <p className="text-lg md:text-xl max-w-2xl mx-auto mb-10 text-gray-700">
            A Árvore está inclusa no material didático de {productYear} de{' '}
            {user?.reader?.entity?.name}.
          </p>
          <div className="space-y-6">
            <div className="flex flex-col items-center gap-4 w-full max-w-xs mx-auto">
              <OrderCodeForm onRedeemed={onRedeemed} />
              <Button
                theme={{ type: 'secondary', size: 'xLarge' }}
                text="Comprar material pela Bookfair"
                onClick={handleClick}
                fluid
              />
              <Button
                theme={{ type: 'ghost', size: 'xLarge' }}
                text="Sair"
                onClick={handleLogoutClick}
                fluid
              />
            </div>

            {hasCriarModuleAndFlag && (
              <section
                aria-labelledby="superautor-section-title"
                className="flex flex-col items-center w-full max-w-xs mx-auto rounded-[10px] border border-solid border-[#dfe5e9] bg-[#f9fafb] px-6 py-5 text-center"
              >
                <h2
                  id="superautor-section-title"
                  className="m-0 mb-1 !text-[17px] font-bold text-[#2d2d2e]"
                >
                  Portal de Criação
                </h2>
                <p className="m-0 !text-[12px] leading-[1.4] text-[#595a5c]">
                  No SuperAutor, alunos escrevem e ilustram seus próprios livros
                  — e lançam em um evento de autógrafos.
                </p>
                <a
                  href={getSuperAutorUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 w-full rounded-[8px] border border-solid border-[#dfe5e9] bg-white px-4 py-2 text-center !text-[12px] font-bold text-[#2d2d2e] no-underline transition-colors hover:bg-[#f3f4f6]"
                >
                  Acessar SuperAutor
                </a>
                <p className="m-0 mt-2 !text-[10px] italic leading-[1.4] text-[#9eaeb7]">
                  O SuperAutor é uma plataforma de escrita e não dá acesso ao
                  acervo de leitura da Árvore.
                </p>
              </section>
            )}
          </div>
        </div>
      </main>

      <footer className="w-full py-8">
        <div className="container mx-auto px-4 text-center">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-6">
            <a href="https://www.arvore.com.br/" className="hover:underline">
              Sobre nós
            </a>
            <a href="https://bit.ly/suporte-arvore" className="hover:underline">
              Contato
            </a>
            <a
              href="https://www.arvore.com.br/arvore-politica-de-privacidade-completo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Política de Privacidade
            </a>
          </div>
          <p className="text-sm text-gray-600">
            © 2025 Árvore. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  )
}
